<template>
  <div>
    <b-row>
      <b-col class="pl-0" cols="10">
        <div class="mb-2">
          Hér eru beiðnir sem hafa verið sendar inn og á eftir að afgreiða, ef nemendur eiga fleiri en eina umsókn óafgreidda þá opnast
          umsóknirnar í hliðarglugga þar sem einnig er hægt að skoða allar umsóknir nemandans óháð stöðu og önn.
        </div>
      </b-col>
      <b-col>
        <b-btn variant="primary" v-if="canEdit" @click="openCreateSlidebar()" class="float-right"
          ><i class="fa fa-plus-circle"></i> Stofna beiðni</b-btn
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pl-0">
        <b-form-group label="Tímabil" label-for="term">
          <v-select id="term" name="term" v-model="selected.term" :options="terms" :multiple="true" :clearable="true"> </v-select>
        </b-form-group>
        <div v-if="selected.term.length > 0">
          <b-form-checkbox v-model="selected.showCommon" class="d-inline-block"></b-form-checkbox>
          Sýna einnig almenn sérúrræði
        </div>
        <div v-else>
          <b-form-checkbox v-model="selected.onlyShowCommon" class="d-inline-block"></b-form-checkbox>
          Sýna eingöngu almenn sérúrræði
        </div>
      </b-col>
      <b-col>
        <b-form-group label="Tegund" label-for="type">
          <v-select id="type" name="type" v-model="selected.type" :options="types" :clearable="true" label="heiti"> </v-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Staða" label-for="status">
          <v-select id="status" name="status" v-model="selected.status" :options="statuses" :clearable="true"> </v-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-btn variant="primary" class="w-100" style="margin-top: 18px" @click="loadList()">Leita</b-btn>
        <div class="cursor-pointer text-right pt-2" @click="detailedSearch = !detailedSearch">
          <span v-if="detailedSearch"><i class="fa fa-angle-up"></i> Fela ítarleit</span>
          <span v-else><i class="fa fa-angle-up"></i> Sýna ítarleit</span>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="detailedSearch">
      <b-col class="pl-0">
        <b-form-group label="Áfangi" label-for="module">
          <b-form-input id="module" name="module" v-model="selected.module" v-on:keyup.enter="loadList"> </b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Deild" label-for="department">
          <v-select id="department" name="department" v-model="selected.department" :options="departments" :clearable="true"> </v-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Nemandi" label-for="student">
          <b-form-input id="student" name="student" v-model="selected.name" v-on:keyup.enter="loadList"> </b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Kennitala" label-for="ssn">
          <b-form-input id="ssn" name="ssn" v-model="selected.ssn" v-on:keyup.enter="loadList"> </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="pl-0">
        <Loader v-if="loading.list" />
        <div v-if="list.length === 0 && !loading.list">Engar óafgreiddar beiðnir</div>
        <table class="table table-hover table-sticky-header less-padding" v-if="list.length > 0" style="font-size: 12px">
          <thead>
            <tr>
              <th v-if="canEdit">
                <b-form-checkbox v-if="oneApplicationList.length > 0" @input="updateSelectAll()" v-model="selectAll"> </b-form-checkbox>
                <b-btn
                  variant="danger"
                  class="btn-xs"
                  style="font-size: 11px"
                  :disabled="deleting"
                  v-if="getSelected.length > 0"
                  @click="deleteSelectedItems()"
                >
                  <i class="fa fa-trash"></i>
                </b-btn>
              </th>
              <th><LinkOrder title="Nafn" :filteredList="list" :list="list" column="nafn" />({{ list.length }})</th>
              <th>
                <LinkOrder title="Kennitala" :filteredList="list" :list="list" column="kennitala" secondColumn="nafn" />
              </th>
              <th class="text-center" v-if="canEdit"><span v-b-tooltip title="Samþykkja" class="fa fa-fw fa-check text-success"></span></th>
              <th class="text-center" v-if="canEdit"><span v-b-tooltip title="Hafna" class="fa fa-fw fa-remove text-danger"></span></th>
              <th class="text-center" v-if="canEdit">
                <span v-b-tooltip title="Í bið" class="fa fa-user-md text-warning"></span>
              </th>
              <th v-if="canEdit">Athugasemd afgreiðslu</th>
              <!--th>
                <LinkOrder title="Staða nema" :filteredList="list" :list="list" column="stada_heiti" secondColumn="nafn" />
              </th>
              <th>
                <LinkOrder title="Vinnslustaða" :filteredList="list" :list="list" column="vinnslustada_heiti" secondColumn="nafn" />
              </th-->
              <th>
                <LinkOrder title="Áfangi" :filteredList="list" :list="list" column="namsgrein_afanganr" secondColumn="nafn" />
              </th>
              <th>
                <LinkOrder title="Kennslutímabil" :filteredList="list" :list="list" column="onn_eink" secondColumn="nafn" />
              </th>
              <th v-for="t in types" :key="t.teg_serurraedi_id">{{ t.heiti }}</th>
              <th>
                <LinkOrder title="Dags" :filteredList="list" :list="list" column="dags" secondColumn="nafn" />
              </th>
              <th>
                <LinkOrder title="Staða" :filteredList="list" :list="list" column="stada" secondColumn="nafn" />
              </th>
              <th>
                <LinkOrder title="Próftími" :filteredList="list" :list="list" column="proftimi" secondColumn="nafn" />
              </th>
              <th>
                <download-csv :data="getExcelData" :name="getExcelFileName" delimiter=";" class="cursor-pointer float-right">
                  <i class="fa fa-file-excel-o excelText"></i>
                </download-csv>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td v-if="canEdit">
                <b-form-checkbox v-if="!item.has_many" v-model="item.selected"> </b-form-checkbox>
              </td>
              <td>
                {{ item.nafn }} {{ item.bekkur }}
                <b-link
                  :to="{ name: 'Student', params: { id: item.nemandi_id } }"
                  target="_blank"
                  v-if="canViewStudent"
                  title="Skoða nemanda"
                  v-b-tooltip
                  ><i class="fa fa-external-link mr-1"></i
                ></b-link>
                <i
                  class="fa fa-search text-primary cursor-pointer"
                  title="Skoða öll sérúrræði"
                  v-b-tooltip
                  @click="openStudentSlidebar(item)"
                  v-if="!item.has_many"
                ></i>
                <div v-if="item && item.skrad_af_nafn && item.skrad_af_nafn !== item.nafn">
                  <i style="font-size: 12px; padding-left: 5px">Skráð af: {{ item.skrad_af_nafn }}</i>
                </div>
              </td>
              <td>{{ item.kennitala }}</td>
              <td class="text-center" v-if="canEdit && !item.has_many">
                <b-form-checkbox v-model="item.confirm" @input="changeSelection(item, 0)" />
              </td>
              <td class="text-center" v-if="canEdit && !item.has_many">
                <b-form-checkbox v-model="item.reject" @input="changeSelection(item, 1)" />
              </td>
              <td class="text-center" v-if="canEdit && !item.has_many">
                <b-form-checkbox v-model="item.wait" :disabled="item.stada === 2" @input="changeSelection(item, 2)" />
              </td>
              <td class="text-center" v-if="canEdit && !item.has_many">
                <b-form-input
                  v-model="item.afgreidsla_athugasemd"
                  style="height: 25px; font-size: 12px; padding: 0px; padding-left: 5px; max-width: 150px"
                ></b-form-input>
              </td>
              <td v-if="!item.has_many">{{ item.namsgrein_afanganr }}</td>
              <td v-if="!item.has_many">{{ item.onn_eink }}</td>

              <td v-for="t in types.filter(x => !item.has_many)" :key="`${index}-${t.teg_serurraedi_id}`" style="max-width: 140px">
                {{ getType(item, t) }}
              </td>
              <td v-if="!item.has_many">{{ item.dags | moment('DD.MM.YYYY') }}</td>
              <td v-if="!item.has_many">{{ item.stada_heiti }}</td>
              <td v-if="!item.has_many">{{ item.proftimi }}</td>
              <td v-if="!item.has_many">
                <b-btn variant="primary" v-if="canEdit" @click="openEditSlidebar(item)" class="btn-xs" style="font-size: 12px"
                  ><i class="fa fa-pencil"></i
                ></b-btn>
              </td>
              <td v-if="item.has_many" colspan="100%">
                <b-link @click="openStudentSlidebar(item)">
                  <i>Afgreiða {{ item.applications }} umsóknir </i>
                </b-link>
              </td>
            </tr>
          </tbody>
        </table>
        <b-btn
          variant="primary"
          class="mb-4"
          :disabled="saving || getSelectedItems.length === 0"
          v-if="list.length > 0 && canEdit"
          @click="processRequests()"
        >
          <i class="fa fa-spin fa-spinner" v-if="saving"></i> Staðfesta</b-btn
        >
      </b-col>
    </b-row>
    <create-request-slidebar v-if="showCreateSlidebar" @closeSlidebar="closeSlidebar" @closeAndReload="closeAndReloadSlidebar" />
    <edit-request-slidebar
      v-if="showEditSlidebar"
      :id="selectedItem ? selectedItem.nemandi_serurraedi_id : ''"
      @closeSlidebar="closeSlidebar"
      @closeAndReload="closeAndReloadSlidebar"
    />
    <student-special-resource-slidebar
      v-if="showStudentSlidebar"
      :id="selectedItem ? selectedItem.nemandi_id : ''"
      :showInfo="true"
      @closeSlidebar="closeSlidebar"
      @reloadData="loadList"
      @closeAndReload="closeAndReloadSlidebar"
    />
  </div>
</template>

<script>
import moment from 'moment';
import requests from '@/api/requests';
import terms from '@/api/terms';
import types from '@/api/types';
import structure from '@/api/structure';
import { mapGetters, mapActions } from 'vuex';

import LinkOrder from '@/components/common/LinkOrder.vue';
import Loader from '@/components/common/Loader.vue';

import CreateRequestSlidebar from '@/components/requests/specialResources/CreateRequestSlidebar.vue';
import EditRequestSlidebar from '@/components/requests/specialResources/EditRequestSlidebar.vue';
import StudentSpecialResourceSlidebar from '@/components/students/student/specialResource/StudentSpecialResourceSlidebar.vue';

export default {
  name: 'special-resources-pending',
  components: {
    Loader,
    LinkOrder,
    CreateRequestSlidebar,
    EditRequestSlidebar,
    StudentSpecialResourceSlidebar,
  },
  computed: {
    getExcelData() {
      const string = [];
      string.push(['Óafgreiddar beiðnir vegna sérúrræða']);

      const headers = [
        'Nafn',
        'Kennitala',
        'Undirskóli',
        'Staða nema',
        'Braut nema',
        'Áfangi',
        'Kennslutímabil',
        'Dags.',
        'Staða',
        'Skráð af',
        'Próftími',
      ];
      if (this.types.some(t => t.active)) {
        this.types.forEach(t => {
          if (t.active) {
            headers.push(t.heiti);
          }
        });
      }

      const items = [];

      this.all.forEach(item => {
        const row = [];

        row.push(item.nafn);
        row.push(item.kennitala);
        row.push(item.undirsk_audk);
        row.push(item.stada_nema_heiti);
        row.push(item.braut);
        row.push(item.namsgrein_afanganr);
        row.push(item.onn_eink);
        row.push(moment(item.dags).format('DD.MM.YYYY'));
        row.push(item.stada_heiti);
        row.push(item.skrad_af_nafn);
        row.push(item.proftimi);

        if (this.types.some(t => t.active)) {
          this.types.forEach(t => {
            if (t.active) {
              const type = (JSON.parse(item.tegundir) || []).find(x => x.teg_serurraedi_id === t.teg_serurraedi_id);
              let value = '';
              if (type) {
                value = (type.text || '').length > 0 ? type.text : 'Já';
              }
              row.push(value);
            }
          });
        }
        items.push(row);
      });

      return [string, headers, ...items];
    },
    getSelectedItems() {
      return this.list.filter(x => x.confirm || x.reject || x.wait);
    },
    oneApplicationList() {
      return this.list.filter(x => !x.has_many);
    },
    getExcelFileName() {
      return `serurraedi_oafgreidd_${moment().format('YYYYMMDD')}_${moment().format('HHmm')}.csv`;
    },
    getSelected() {
      return this.list.filter(x => x.selected);
    },
    canEdit() {
      return this.loggedInUserHasWritePermission('beidnir_serurraedi');
    },
    canViewStudent() {
      return this.loggedInUserHasWritePermission('nemendahald_nemendur');
    },
    ...mapGetters(['loggedInUserHasReadPermission', 'loggedInUserHasWritePermission']),
  },
  data() {
    return {
      loading: {
        list: false,
        terms: false,
        types: false,
      },
      saving: false,
      deleting: false,
      detailedSearch: false,
      selectAll: false,
      selected: {
        term: [],
        module: '',
        type: '',
        name: '',
        ssn: '',
        status: '',
        showCommon: true,
        onlyShowCommon: false,
        department: '',
      },
      all: [],
      list: [],
      terms: [],
      types: [],
      departments: [],
      statuses: [
        { id: 0, label: 'Óafgreidd' },
        { id: 2, label: 'Í bið' },
      ],
      selectedItem: '',
      showCreateSlidebar: false,
      showEditSlidebar: false,
      showStudentSlidebar: false,
    };
  },
  methods: {
    updateSelectAll() {
      this.oneApplicationList.forEach(item => {
        this.$set(item, 'selected', this.selectAll);
      });
    },
    getType(item, type) {
      const data = (item.tegundir || []).find(x => x.teg_serurraedi_id === type.teg_serurraedi_id);
      let value = '';
      if (data) {
        value = (data.text || '').length > 0 ? data.text : 'Já';
      }
      return value;
    },
    changeSelection(item, type) {
      if (type === 0 && item.confirm) {
        this.$set(item, 'confirm', true);
        this.$set(item, 'reject', false);
        this.$set(item, 'wait', false);
      } else if (type === 1 && item.reject) {
        this.$set(item, 'confirm', false);
        this.$set(item, 'reject', true);
        this.$set(item, 'wait', false);
      } else if (type === 2 && item.wait) {
        this.$set(item, 'reject', false);
        this.$set(item, 'confirm', false);
        this.$set(item, 'wait', true);
      }
    },
    getStatus(item) {
      if (item.confirm) return 1;
      if (item.wait) return 2;
      if (item.reject) return 3;
      return 0;
    },
    async loadList() {
      try {
        this.loading.list = true;
        this.list = [];
        const item = {
          status: this.selected.status ? this.selected.status.id : '0,2',
          term: this.selected.term ? this.selected.term.map(x => x.onn_id).join(',') : '',
          module: this.selected.module,
          type: this.selected.type ? this.selected.type.teg_serurraedi_id : '',
          name: this.selected.name,
          ssn: this.selected.ssn,
          department: this.selected.department ? this.selected.department.department_id : '',
          showCommon: this.selected.term && this.selected.showCommon ? 1 : '',
          onlyShowCommon: !this.selected.term && this.selected.onlyShowCommon ? 1 : '',
        };
        const response = await requests.getSpecialResources(item);
        this.all = response.data.items;
        this.all.forEach(a => {
          const studentRequests = response.data.items.filter(x => x.nemandi_id === a.nemandi_id);
          const exists = this.list.find(x => x.nemandi_id === a.nemandi_id);
          if (!exists) {
            const student = {
              braut: a.braut,
              kennitala: a.kennitala,
              nafn: a.nafn,
              bekkur: a.bekkur,
              nemandi_id: a.nemandi_id,
              proftimi: a.proftimi,
              stada_nema_heiti: a.stada_nema_heiti,
            };
            if (studentRequests.length === 1) {
              student.has_many = false;
              student.dags = a.dags;
              student.namsgrein_afanganr = a.namsgrein_afanganr;
              student.nemandi_serurraedi_id = a.nemandi_serurraedi_id;
              student.onn_eink = a.onn_eink;
              student.skrad_af_nafn = a.skrad_af_nafn;
              student.stada = a.stada;
              student.skrad_af_nafn = a.skrad_af_nafn;
              student.tegundir = a.tegundir ? JSON.parse(a.tegundir) : [];
              student.stada_heiti = this.statuses.find(y => y.id === a.stada) ? this.statuses.find(y => y.id === a.stada).label : '';
            } else if (studentRequests.length > 1) {
              student.has_many = true;
              student.applications = studentRequests.length;
            }
            this.list.push(student);
          }
        });
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading.list = false;
      }
    },
    async loadTerms() {
      try {
        this.loading.terms = true;
        const response = await terms.getTerms();
        this.terms = response.data.items.map(x => ({
          ...x,
          label: `${x.undirsk_audk} - ${x.onn_heiti}`,
        }));
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading.terms = false;
      }
    },
    async loadTypes() {
      try {
        this.loading.types = true;
        const response = await types.getSpecialResourceList();
        this.types = response.data.items;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading.types = false;
      }
    },
    async loadDepartments() {
      try {
        const response = await structure.getDepartmentList();
        this.departments = response.data.items.map(x => ({
          ...x,
          label: `${x.name}`,
        }));
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      }
    },
    async processRequests() {
      try {
        this.saving = true;
        // 0 - nýskráð, 1 - samþykkt, 2 - bið, 3 - hafnað
        const data = this.getSelectedItems.map(x => ({
          id: x.nemandi_serurraedi_id,
          status: this.getStatus(x),
          afgreidsla_athugasemd: x.afgreidsla_athugasemd,
        }));

        await requests.processSpecialResources(data);
        this.displaySuccess('Beiðnir afgreiddar');
        this.loadList();
      } catch (e) {
        // Aðgerð mistókst.
        this.failed = true;
        this.$log.debug(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.saving = false;
      }
    },
    async deleteSelectedItems() {
      try {
        this.deleting = true;
        const conf = confirm(`Ert þú viss um að þú viljir eyða ${this.getSelected.length} beiðnum? \nEkki verður sendur póstur.`); // eslint-disable-line
        if (conf) {
          const ids = this.getSelected.map(x => x.nemandi_serurraedi_id).join(',');
          await requests.massEditSpecialResources({
            deleted: 1,
            ids,
          });
          this.displaySuccess('Beiðnum eytt');
          this.loadList();
        }
      } catch (e) {
        // Aðgerð mistókst.
        this.failed = true;
        this.$log.debug(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.deleting = false;
      }
    },
    openCreateSlidebar() {
      this.showCreateSlidebar = true;
      this.showEditSlidebar = false;
      this.showStudentSlidebar = false;
    },
    openEditSlidebar(item) {
      this.selectedItem = item;
      this.showEditSlidebar = true;
      this.showCreateSlidebar = false;
      this.showStudentSlidebar = false;
    },
    openStudentSlidebar(item) {
      this.selectedItem = item;
      this.showStudentSlidebar = true;
      this.showEditSlidebar = false;
      this.showCreateSlidebar = false;
    },
    closeSlidebar() {
      this.selectedItem = null;
      this.showEditSlidebar = false;
      this.showCreateSlidebar = false;
      this.showStudentSlidebar = false;
    },
    closeAndReloadSlidebar(item) {
      if (item && item.ssn) {
        this.$emit('goToSsn', item.ssn);
      }
      this.closeSlidebar();
      this.loadList();
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  created() {
    this.loadTerms();
    this.loadList();
    this.loadTypes();
    this.loadDepartments();
  },
};
</script>
<style lang="scss"></style>
